<template>
  <transition name="el-zoom-in-top">
    <div
      class="drawer-wrap"
      v-show="drawer"
      :class="{
        isMobile: isMobile,
        menuIsShow: menuIsShow,
        showDown: showDown,
        topNavigationRight: topNavigationRight,
        topNavigationNone: topNavigationNone,
        topNavigation2: topNavigation2,
        topNavigation4: topNavigation4,
      }"
    >
      <div class="drawer-content" @click.stop="">
        <div class="content-box">
          <div class="flex-row input-wrap">
            <el-input
              :placeholder="$t('Datalang.Betrecord_TITLE_gamename')"
              prefix-icon="el-icon-search"
              ref="searchRef"
              :autofocus="true"
              v-model="searchKey"
            >
              <template slot="suffix">
                <div class="cancel-btn" @click="searchKey = ''">{{ $t("Datalang.Signin_TITLE_cancel") }}</div>
              </template>
            </el-input>
            <i
              class="el-icon-close close-icon"
              @click="changeShow(false)"
              v-exposure="{ eid: `101_0_0_128` }"
              :data-id="`101_0_0_128`"
            ></i>
          </div>
          <div class="search-tips" v-show="!showResult">{{ $t("Datalang.Search_for_games") }}</div>
          <div class="search-result" v-show="showResult">
            <div class="result-title">
              <span class="title">{{ $t("Datalang.Search_results") }}</span> <span v-show="!loading"></span>
            </div>
            <div class="result" v-loading="loading">
              <div class="empty" v-show="!gameList.length && !loading">
                <img :src="zanwu" alt="" />
                <div>{{ $t("Datalang.Invite_TITLE_nodatanow") }}</div>
              </div>
              <div class="list" v-show="gameList.length">
                <div class="p-hot-box" v-if="!isMobile">
                  <template v-for="(item, i) in gameList">
                    <div class="img-box" v-if="hidegd(item)" :key="'pc_' + i" :class="{ 'mr-0': (i + 1) % 6 === 0 }">
                      <gameItem :item="item" :jp_show="jp_show" />
                    </div>
                  </template>
                </div>
                <div class="p-hot-box" v-if="isMobile">
                  <template v-for="(item, i) in gameList">
                    <div
                      class="img-box h5-box"
                      v-if="hidegd(item)"
                      :key="'h5_' + i"
                      :class="{ 'mr-0': (i + 1) % 3 === 0 }"
                    >
                      <gameItem :item="item" :jp_show="jp_show" />
                    </div>
                  </template>
                </div>
                <div class="more-btn-box" v-if="hasMore">
                  <div class="more-btn" @click="moreFun">{{ $t("Datalang.HomePage_BTM_loadmore") }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="history-wrap" v-show="!showResult">
            <div class="history-title">
              <span class="title">{{ $t("Datalang.Search_History") }}</span>
              <i @click="clearKeys" class="el-icon-delete-solid"></i>
            </div>
            <div class="history-key">
              <div
                v-for="(key, index) in historyList"
                @click.stop="setKey(key)"
                @touchend.stop="setKey(key)"
                :key="index"
                class="key"
              >
                {{ key }} <i class="el-icon-close" @click.stop="delKey(key)" @touchend.stop="setKey(key)"></i>
              </div>
            </div>
          </div>
          <game-hot :isHistory="true"></game-hot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import searchDrawer from "@/lobby_common/mixins_components/searchDrawer/index.js";
export default {
  name: "searchDrawer",
  components: {},
  props: [],
  mixins: [searchDrawer],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.more-btn-box {
  width: 100%;
  padding: 10px 0;
  text-align: center;
  .more-btn {
    display: inline-block;
    padding: 0 15px;
    height: 32px;
    line-height: 32px;
    margin: 0 auto;
    margin-bottom: 16px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
    @include buttonPrimary;
  }
}
.p-hot-box {
  width: 100%;

  .img-box {
    position: relative;
    display: inline-block;
    width: 15%;
    margin: 0 auto;
    margin-right: 2%;
    margin-bottom: 16px;
    text-align: center;
    cursor: pointer;
    &.h5-box {
      width: 28%;
      margin-right: 8%;
    }

    ::v-deep .el-image__inner {
      transition: 0.5s;

      &:hover {
        transform: scale(1.4);
        transition: all 1s ease 0s;
        -webkit-transform: scale(1.4);
        -webkit-transform: all 1s ease 0s;
      }
    }

    .relative {
      img {
        max-width: 100%;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        -ms-border-radius: 20px;
        -o-border-radius: 20px;
      }
    }

    &.mr-0 {
      margin-right: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .txt {
      width: 100%;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      /*不换行*/
      text-overflow: ellipsis;
      /*超出部分文字以...显示*/
    }
  }
}

.drawer-wrap {
  position: fixed;
  top: 60px;
  left: 64px;
  width: calc(100% - 64px);
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* 半透明的黑色背景 */
  z-index: 2000;
  /* 确保遮罩层位于其他内容之上 */
  overflow: hidden;
  &.menuIsShow {
    left: 300px;
    width: calc(100% - 300px);
    &.topNavigationRight {
      left: 0 !important;
    }
    &.topNavigation2,
    &.topNavigation4,
    &.topNavigationNone {
      left: 0 !important;
      right: 0 !important;
      width: 100% !important;
    }
    &.topNavigation4 {
      top: 100px;
    }
  }
  &.topNavigationRight {
    left: 0 !important;
  }
  &.isMobile {
    top: 50px;
    left: 0;
    width: 100%;
    .input-wrap {
      position: sticky;
      top: 0;
      overflow: hidden;
      padding-top: 15px;
      z-index: 99;
    }
    &.showDown {
      top: 90px;
      &.menuIsShow {
        top: 50px;
      }
    }

    .drawer-content {
      padding: 0;
      height: calc(100% - 110px);
      .content-box {
        padding: 0 10px;
      }
    }
    .list {
      max-height: none;
      overflow-y: auto;
    }
  }

  .list {
    max-height: 520px;
    overflow-y: scroll;
  }

  .drawer-content {
    background: var(--background-1200);
    padding: 30px 0 0;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    overflow-y: scroll;
    .search-tips {
      text-align: center;
      margin: 15px 0;
      font-size: 12px;
    }
    .flex-row {
      display: flex;
      align-items: center;
    }
    .close-icon {
      font-size: 24px;
      cursor: pointer;
      padding: 0 10px;
    }
    .content-box {
      width: 100%;
      max-width: 1340px;
      min-height: 400px;
      margin: 0 auto;
      padding: 0 35px;
      box-sizing: border-box;
    }

    .search-result {
      min-height: 50px;

      .empty {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        background: transparent;

        img {
          display: inline-block;
          width: 100px;
          height: 97px;
        }
      }
    }

    .history-title,
    .result-title {
      margin: 15px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title {
        color: var(--font-color-100);
      }

      .el-icon-delete-solid {
        cursor: pointer;

        &:hover {
          color: var(--font-color-300);
        }
      }
    }

    .history-wrap {
      margin: 20px 0;
    }

    .history-key {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .key {
        margin-right: 20px;
        margin-bottom: 10px;
        cursor: pointer;
        padding: 10px 0;
        display: flex;
        align-items: center;
        color: var(--font-color-900);
        border-bottom: 1px solid var(--font-color-900);

        .el-icon-close {
          display: none;
          margin-left: 10px;
        }

        &:hover {
          .el-icon-close {
            display: inline-block;

            &:hover {
              color: var(--font-color-500);
            }
          }
        }
      }
    }

    .cancel-btn {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      margin: 0 15px;
    }
  }
}
</style>
